import React, { useState, useEffect } from 'react';

import { IComponentTime } from '../../component.d';
import { RenderRequired } from './Form';
import moment from 'moment';

const HOURS = (() => {
  let result = [];
  for (var i = 0; i < 24; i++) {
    result.push({
      value: i,
      label: (i < 10 ? `0${i}` : `${i}`) + '点'
    });
  }

  return result;
})();
const TIMES = (() => {
  let result = [];
  for (var i = 0; i < 59; i++) {
    result.push({
      value: i,
      label: (i < 10 ? `0${i}` : `${i}`) + '分'
    });
  }

  return result;
})();

const AllForFormInput = function(props: IComponentTime) {
  const { field, align, width, onChange, required, label, type } = props;

  const [data, setData] = useState('');

  return (
    <div className="all-for-time">
      <div
        className="weui-cells__group weui-cells__group_form"
        style={{ width: `${width}%` }}
      >
        <div className="weui-cells">
          <div
            className="weui-cell weui-cell_active weui-cell_access"
            onClick={() => {
              window.weui!.picker(HOURS, TIMES, {
                onChange: (result: any) => {
                  // console.log(`change`, result);
                },
                onConfirm: (result: any) => {
                  let date = new Date();
                  date.setHours(result[0].value);
                  date.setMinutes(result[1].value);

                  let format = moment(date).format('HH:mm');
                  setData(format);
                  onChange(type, field, format);
                },
                title: field
              });
            }}
          >
            <div className="weui-cell__bd">
              {field} {RenderRequired(required)}
            </div>
            <div className="weui-cell__ft">{data}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllForFormInput;
